import { useConstant, createSignal } from "@builder.io/qwik";
const useBoundSignal = (givenSignal, initialValue) => useConstant(() => givenSignal || createSignal(initialValue));
export {
  useBoundSignal
};
